import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate } from 'react-intl';

import DatePicker from 'material-ui/DatePicker';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import TextField from 'material-ui/TextField';

import SortAlphaIcon from 'material-ui/svg-icons/av/sort-by-alpha';

const sortMethods = {
    default:       (a, b) => a.id - b.id,
    fullName:      (a, b) => a.fullName.localeCompare(b.fullName),
    moduleName:    (a, b) => !!a.moduleName ? a.moduleName.localeCompare(b.moduleName) : !!b.moduleName,
    enrolmentDate: (a, b) => a.enrolmentDate.localeCompare(b.enrolmentDate),
    attemptDate:   (a, b) => a.attemptDate.localeCompare(b.attemptDate)
};

class ReportElearningAttemptsHistory extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            sortName: 'default',
            sort: sortMethods.default,
            statuses: ['passed', 'failed', 'unknown'],
            filters: {
                fullName: '',
                moduleName: '',
                enrolledFrom: '',
                enrolledFromTime: 0,
                enrolledTo: '',
                enrolledToTime: 0,
                status: '',
                scoreMin: '',
                scoreMax: '',
                attemptedFrom: '',
                attemptedFromTime: '',
                attemptedTo: '',
                attemptedToTime: '',
            }
        };
    }

    componentDidMount() {
        this.setSort = this.setSort.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setTextFilter = this.setTextFilter.bind(this);
        this.filterData = this.filterData.bind(this)
    }

    render() {
        const data = this.props.data
            .filter(this.filterData)
            .sort(this.state.sort);

        const tableHeaderProps = {
            enableSelectAll:   this.props.display.enableSelectAll,
            displaySelectAll:  this.props.display.enableSelectAll,
            adjustForCheckbox: this.props.display.enableSelectAll
        };
        let tableProps = {
            height:             this.props.display.height,
            fixedHeader:        this.props.display.fixedHeader,
            fixedFooter:        this.props.display.fixedFooter,
            displayRowCheckbox: !!this.props.showCheckboxes,
            selectable:         this.props.display.selectable,
            multiSelectable:    this.props.display.multiSelectable,
        };
        const tableBodyProps = {
            deselectOnClickaway: this.props.display.deselectOnClickaway,
            displayRowCheckbox:  this.props.display.showCheckboxes,
            showRowHover:        this.props.display.showRowHover,
            stripedRows:         this.props.display.stripedRows,
        };

        if (!!this.props.onRowSelect) {
            tableProps.onRowSelection = this.props.onRowSelect;
        }

        const style = { width: '100%' };
        const textFilterProps = {
            hintText: 'Filter',
            onChange: (event) => this.setFilter(event.target.name, event.target.value.toLocaleLowerCase()),
            style
        };
        const dropdownFilterProps = {
            hintText: 'Filter',
            onChange: (event, i, value) => this.setFilter('status', value),
            style
        };
        const dateFilterProps = {
            formatDate:     (date) => (date instanceof Date ? date.toLocaleDateString() : null),
            style,
            textFieldStyle: style
        };

        let minFilterProps = {
            hintText: 'Minimum',
            onChange: this.setTextFilter,
            style:    style.textFilter
        };
        if (this.state.filters.scoreMin !== '' && isNaN(Number(this.state.filters.scoreMin))) {
            minFilterProps.errorText = 'Please enter a number';
        }
        let maxFilterProps = {
            hintText: 'Maximum',
            onChange: this.setTextFilter,
            style:    style.textFilter
        };
        if (this.state.filters.scoreMax !== '' && isNaN(Number(this.state.filters.scoreMax))) {
            maxFilterProps.errorText = 'Please enter a number';
        }

        return (
            <Table {...tableProps} >
                <TableHeader {...tableHeaderProps} >
                    <TableRow>
                        <TableHeaderColumn>Name
                            <IconButton onTouchTap={this.setSort('fullName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Module name
                            <IconButton onTouchTap={this.setSort('moduleName')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Enrolment date
                            <IconButton onTouchTap={this.setSort('enrolmentDate')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                        <TableHeaderColumn>Status</TableHeaderColumn>
                        <TableHeaderColumn>Score</TableHeaderColumn>
                        <TableHeaderColumn>Attempt date
                            <IconButton onTouchTap={this.setSort('attemptDate')} >
                                <SortAlphaIcon />
                            </IconButton>
                        </TableHeaderColumn>
                    </TableRow>
                    <TableRow>
                        <TableHeaderColumn>
                            <TextField name="fullName" value={this.state.filters.fullName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="moduleName" value={this.state.filters.moduleName} {...textFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('enrolmentFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('enrolmentTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <SelectField name="status" value={this.state.filters.status} {...dropdownFilterProps}>
                                <MenuItem value="" primaryText="No filter" label=" " />
                                {this.state.statuses.map((status, index) => <MenuItem key={index} value={status} primaryText={status} />)}
                            </SelectField>
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <TextField name="scoreMin" value={this.state.filters.scoreMin} {...minFilterProps} /><br />
                            <TextField name="scoreMax" value={this.state.filters.scoreMax} {...maxFilterProps} />
                        </TableHeaderColumn>
                        <TableHeaderColumn>
                            <DatePicker hintText="From" onChange={(e,v) => this.setFilter('attemptedFrom', v)} {...dateFilterProps} />
                            <DatePicker hintText="To"   onChange={(e,v) => this.setFilter('attemptedTo', v)}   {...dateFilterProps} />
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody {...tableBodyProps} >
                    {data.map((row, index) => (
                        <TableRow key={index} selected={row.selected}>
                            <TableRowColumn>{row.fullName}</TableRowColumn>
                            <TableRowColumn>{row.moduleName}</TableRowColumn>
                            <TableRowColumn>
                                {(!!row.enrolmentDate && !isNaN(Date.parse(row.enrolmentDate))) && (
                                    <FormattedDate {...DateStyles.long} value={row.enrolmentDate} />
                                )}
                            </TableRowColumn>
                            <TableRowColumn>{row.status}</TableRowColumn>
                            <TableRowColumn>{row.score}</TableRowColumn>
                            <TableRowColumn>
                                {(!!row.attemptDate && !isNaN(Date.parse(row.attemptDate))) && (
                                    <FormattedDate {...DateStyles.shortDateTime} value={row.attemptDate} />
                                )}
                            </TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }

    setSort(sort) {
        return () => {
            if (sortMethods.hasOwnProperty(sort) && this.state.sortName !== sort) {
                this.setState({sortName: sort, sort: sortMethods[sort]});
            }
        };
    }

    setFilter(filter, value) {
        if (this.state.filters.hasOwnProperty(filter)) {
            const filters = {
                ...this.state.filters,
                [filter]: value
            };
            const time = `${filter}Time`;
            if (filters.hasOwnProperty(time)) {
                filters[time] = (value instanceof Date ? value.getTime() : '');
            }
            this.setState({filters: filters});
        }
    }

    setTextFilter(event) {
        this.setFilter(event.target.name, event.target.value.toLocaleLowerCase());
    }

    filterData(row) {
        if (row === undefined) { return; }
        let valid = true;
        if (valid && !!this.state.filters.fullName) {
            valid = (-1 < row.fullName.toLocaleLowerCase().search(this.state.filters.fullName));
        }

        if (valid && !!this.state.filters.moduleName) {
            valid = (!!row.moduleName && -1 < row.moduleName.toLocaleLowerCase().search(this.state.filters.moduleName));
        }

        const enrolmentDate = (new Date(row.enrolmentDate)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.enrolledFrom) {
            valid = (!!enrolmentDate && this.state.filters.enrolledFromTime <= enrolmentDate);
        }
        if (valid && !!this.state.filters.enrolledTo) {
            valid = (!!enrolmentDate && enrolmentDate <= this.state.filters.enrolledToTime );
        }

        if (valid && !!this.state.filters.status) {
            valid = row.status === this.state.filters.status;
        }

        if (valid && this.state.filters.scoreMin !== '' && !isNaN(Number(this.state.filters.scoreMin))) {
            valid = (this.state.filters.scoreMin <= row.score);
        }

        if (valid && this.state.filters.scoreMax !== '' && !isNaN(Number(this.state.filters.scoreMax))) {
            valid = (row.score <= this.state.filters.scoreMax);
        }

        const attemptDate = (new Date(row.attemptDate)).setHours(0, 0, 0);
        if (valid && !!this.state.filters.attemptedFrom) {
            valid = (!!attemptDate && this.state.filters.attemptedFromTime <= attemptDate);
        }
        if (valid && !!this.state.filters.attemptedTo) {
            valid = (!!attemptDate && attemptDate <= this.state.filters.attemptedToTime );
        }

        return valid;
    }
}

ReportElearningAttemptsHistory.propTypes = {
    display: PropTypes.object,
    onRowSelect: PropTypes.func,
    data: PropTypes.arrayOf(PropTypes.object),
};

ReportElearningAttemptsHistory.defaultProps = {
    display: {
        fixedHeader: true,
        fixedFooter: true,
        stripedRows: false,
        showRowHover: false,
        showCheckboxes: false,
        selectable: false,
        multiSelectable: false,
        enableSelectAll: false,
        deselectOnClickaway: false,
    },
    data: []
};

export default ReportElearningAttemptsHistory;
